import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ui-kit" }
const _hoisted_2 = { class: "ui-kit__wrapper" }
const _hoisted_3 = { class: "ui-kit__grid" }
const _hoisted_4 = { class: "ui-kit__container" }
const _hoisted_5 = { class: "ui-kit__text" }
const _hoisted_6 = { class: "ui-kit__row" }
const _hoisted_7 = { class: "ui-kit__container" }
const _hoisted_8 = { class: "ui-kit__row --line --wrap" }
const _hoisted_9 = { class: "ui-kit__container" }
const _hoisted_10 = { class: "ui-kit__row --line --wrap" }
const _hoisted_11 = { class: "ui-kit__container" }
const _hoisted_12 = { class: "ui-kit__row --line --wrap" }
const _hoisted_13 = { class: "ui-kit__container" }
const _hoisted_14 = { class: "ui-kit__row" }
const _hoisted_15 = { class: "ui-kit__container" }
const _hoisted_16 = { class: "ui-kit__row --line --wrap" }
const _hoisted_17 = { class: "ui-kit__container" }
const _hoisted_18 = { class: "ui-kit__row" }
const _hoisted_19 = { class: "ui-kit__container" }
const _hoisted_20 = { class: "ui-kit__row" }
const _hoisted_21 = { class: "ui-kit__container" }
const _hoisted_22 = { class: "ui-kit__row" }
const _hoisted_23 = { class: "ui-kit__container" }
const _hoisted_24 = { class: "ui-kit__row --line --wrap --grey-bg" }
const _hoisted_25 = { class: "ui-kit__container" }
const _hoisted_26 = { class: "ui-kit__row --line --grey-bg" }
const _hoisted_27 = { class: "ui-kit__container" }
const _hoisted_28 = { class: "ui-kit__row --line" }

import BaseButton from "@/components/base/BaseButton.vue";
import Balance from "@/components/balance/Balance.vue";
import TariffMain from "@/components/tariff/TariffMain.vue";
import { reactive, ref } from "vue";
import { TariffOptionStruct } from "@/struct/TariffStruct";
import AddonsMain from "@/components/addons/AddonsMain.vue";
import { AddonsItemStruct } from "@/struct/AddonsStruct";
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import type { Base64File } from "@/struct/FileTypes";
import BaseDrop from "@/components/base/BaseDrop.vue";
import BaseFeedback from "@/components/base/BaseFeedback.vue";
import BaseInput from "@/components/base/BaseInput.vue";
import BaseModal from "@/components/base/BaseModal.vue";
import BaseProgressBar from "@/components/base/BaseProgressBar.vue";
import BasePromocode from "@/components/base/BasePromocode.vue";
import BaseSelect from "@/components/base/BaseSelect.vue";
import BaseSwitcher from "@/components/base/BaseSwitcher.vue";
import { useStore } from "@/store";
import { TypesModals } from "@/config/modals";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'UiKitMain',
  setup(__props) {

const store = useStore();
const { t } = useI18n();

const options = reactive<TariffOptionStruct[]>([
  {
    value: 185,
    maximum: 300,
    id: "gb",
  },
  {
    value: 5,
    maximum: 10,
    id: "min",
  },
  {
    value: 0,
    maximum: 10,
    id: "sms",
  },
]);
const optionsBlocked = reactive<TariffOptionStruct[]>([
  {
    value: 0,
    maximum: 300,
    id: "gb",
  },
  {
    value: 0,
    maximum: 10,
    id: "min",
  },
  {
    value: 0,
    maximum: 10,
    id: "sms",
  },
]);

const isAccepted = ref<boolean>(false);
const files = ref<Base64File[]>([]);
const feedbackModal = ref<boolean>(false);
const isOpenBaseModal = ref<boolean>(false);
const activeValue = ref(50);
const maxValue = ref(200);

const formInput = reactive({
  phone: "",
  code: "",
  digit: "",
  email: "",
  text: "",
  area: "",
});

const addons = reactive<AddonsItemStruct[]>([
  {
    title: t("uiKit.samples.unlimitedMessengers"),
    amount: 0,
    date: t("uiKit.labels.sampleDate"),
    servicesList: ["yandex-maps", "yandex-music", "vk", "ok", "rutube"],
  },
  {
    title: t("uiKit.samples.roamingInternet"),
    amount: 12,
    date: t("uiKit.labels.sampleDate"),
    unitData: {
      value: 50,
      maximum: 300,
      id: "gb",
    },
  },
  {
    title: t("uiKit.samples.roamingInternet"),
    amount: 0,
    date: t("uiKit.labels.sampleDate"),
    unitData: {
      value: 0,
      maximum: 10,
      id: "sms",
    },
  },
]);

const itemsSelect = ref(["Элемент1", "Элемент2", "Элемент3", "Элемент4"]);
const selected = ref("Элемент1");
const handleFeedbackSubmitResult = (isSuccess: boolean) => {
  alert(`handleFeedbackSubmitResult => isSuccess: ${isSuccess}`);
};
const openBaseFeedback = () => {
  feedbackModal.value = true;
};
const presetKeys = ref<TypesModals>(["no_funds", "general_error"]);
const openBaseModal = (modalKey: TypesModals) => {
  store.dispatch("system/openModal", {
    presetKey: modalKey,
    /*overrides: {
    все поля overrides опциональны
      title: "С предыдущей смены номера не прошло 6 месяцев",
      mainBtnTitle: "Продолжить"

      text?: string;
      status?: "success" | "default" | "error";
      secondaryBtnTitle?:
      mainBtnLoading?: boolean;
      secondaryBtnLoading?: boolean;

      onAction?: () => void; (default: закрытие) приписать если нужно иное
      onSecondaryAction?: () => void;
    },*/
  });
};
const toggleModal = (state: boolean) => {
  isOpenBaseModal.value = state;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)("uiKit.labels.buttonsFullWidth")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(BaseButton, {
              title: _unref(t)('uiKit.samples.topUp'),
              size: "large",
              color: "primary"
            }, null, 8, ["title"]),
            _createVNode(BaseButton, {
              title: _unref(t)('uiKit.samples.topUp'),
              size: "large",
              color: "grey"
            }, null, 8, ["title"]),
            _createVNode(BaseButton, {
              title: _unref(t)('uiKit.samples.topUp'),
              size: "large",
              color: "transparent-white"
            }, null, 8, ["title"]),
            _createVNode(BaseButton, {
              title: _unref(t)('uiKit.samples.topUp'),
              size: "large",
              color: "transparent-black"
            }, null, 8, ["title"]),
            _createVNode(BaseButton, {
              title: _unref(t)('uiKit.samples.topUp'),
              size: "large",
              color: "white"
            }, null, 8, ["title"]),
            _createVNode(BaseButton, {
              title: _unref(t)('uiKit.samples.topUp'),
              size: "medium",
              color: "primary"
            }, null, 8, ["title"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "ui-kit__text" }, [
          _createElementVNode("span", null, "BaseCheckbox ")
        ], -1)),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(BaseCheckbox, {
            modelValue: isAccepted.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAccepted).value = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "ui-kit__text" }, [
          _createElementVNode("span", null, "BaseDrop ")
        ], -1)),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(BaseDrop, {
            "onUpdate:files": _cache[1] || (_cache[1] = ($event: any) => (files.value = $event))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "ui-kit__text" }, [
          _createElementVNode("span", null, "BaseFeedback ")
        ], -1)),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(BaseButton, {
            title: "Открыть BaseFeedback",
            onClick: openBaseFeedback
          }),
          _createVNode(BaseFeedback, {
            modelValue: feedbackModal.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((feedbackModal).value = $event)),
            onSubmitResult: handleFeedbackSubmitResult
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "ui-kit__text" }, [
          _createElementVNode("span", null, "BaseInput ")
        ], -1)),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(BaseInput, {
            modelValue: formInput.phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formInput.phone) = $event)),
            type: "phone",
            placeholder: "Номер телефона"
          }, null, 8, ["modelValue"]),
          _createVNode(BaseInput, {
            modelValue: formInput.code,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formInput.code) = $event)),
            type: "code",
            placeholder: "Код"
          }, null, 8, ["modelValue"]),
          _createVNode(BaseInput, {
            modelValue: formInput.digit,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formInput.digit) = $event)),
            type: "digit",
            placeholder: "Number",
            "max-length": 11
          }, null, 8, ["modelValue"]),
          _createVNode(BaseInput, {
            modelValue: formInput.email,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formInput.email) = $event)),
            type: "email",
            placeholder: "Email"
          }, null, 8, ["modelValue"]),
          _createVNode(BaseInput, {
            modelValue: formInput.text,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formInput.text) = $event)),
            type: "text",
            placeholder: "Text"
          }, null, 8, ["modelValue"]),
          _createVNode(BaseInput, {
            modelValue: formInput.area,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formInput.area) = $event)),
            type: "area",
            placeholder: "Textarea"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "ui-kit__text" }, [
          _createElementVNode("span", null, "BaseModal ")
        ], -1)),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(presetKeys.value, (modalKey, index) => {
            return (_openBlock(), _createBlock(BaseButton, {
              key: index,
              title: `Open BaseModal ${modalKey}`,
              onClick: ($event: any) => (openBaseModal(modalKey))
            }, null, 8, ["title", "onClick"]))
          }), 128)),
          (isOpenBaseModal.value)
            ? (_openBlock(), _createBlock(BaseModal, {
                key: 0,
                title: "Произошла ошибка",
                "main-btn-title": "Закрыть окно",
                status: "error",
                onClose: _cache[9] || (_cache[9] = ($event: any) => (toggleModal(false))),
                onAction: _cache[10] || (_cache[10] = ($event: any) => (toggleModal(false)))
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "ui-kit__text" }, [
          _createElementVNode("span", null, "BaseProgressBar ")
        ], -1)),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(BaseProgressBar, {
            "current-amount": activeValue.value,
            "max-amount": maxValue.value
          }, null, 8, ["current-amount", "max-amount"])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "ui-kit__text" }, [
          _createElementVNode("span", null, "BasePromocode ")
        ], -1)),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(BasePromocode)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "ui-kit__text" }, [
          _createElementVNode("span", null, "BaseSelect ")
        ], -1)),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(BaseSelect, {
            placeholder: "Выбор",
            items: itemsSelect.value,
            modelValue: selected.value,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((selected).value = $event))
          }, null, 8, ["items", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "ui-kit__text" }, [
          _createElementVNode("span", null, "Blocks ")
        ], -1)),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(Balance, { amount: 1490 }),
          _createVNode(TariffMain, {
            amount: 250,
            "old-amount": 500,
            "discount-percent": 50,
            options: options,
            "next-date": "30 декабря"
          }, null, 8, ["options"]),
          _createVNode(TariffMain, {
            amount: 250,
            "old-amount": 500,
            "discount-percent": 50,
            options: optionsBlocked,
            "next-date": "30 декабря"
          }, null, 8, ["options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "ui-kit__text" }, [
          _createElementVNode("span", null, "Blocks Addons ")
        ], -1)),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(AddonsMain, { options: addons }, null, 8, ["options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "ui-kit__text" }, [
          _createElementVNode("span", null, "BaseSwitcher ")
        ], -1)),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(BaseSwitcher)
        ])
      ])
    ])
  ]))
}
}

})